import {
  Actions,
  Box,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import { ButtonLink, TextLink } from '../Link/Link';

import * as styles from './FeaturePromoBlock.css';

interface LinkProps {
  linkText: string;
  linkHref: string;
  component?: 'Text' | 'Button';
  tracking: string;
}

const CustomLink = ({ data }: { data: LinkProps }) =>
  data.component === 'Text' ? (
    <Text>
      <TextLink href={data.linkHref} tracking={data.tracking}>
        {data.linkText}
      </TextLink>
    </Text>
  ) : (
    <Box paddingTop={['gutter', 'small']}>
      <Actions>
        <ButtonLink href={data.linkHref} tracking={data.tracking}>
          {data.linkText}
        </ButtonLink>
      </Actions>
    </Box>
  );

export const FeaturePromoBlock = ({
  title,
  text,
  image,
  cta,
  background = 'none',
  reverse,
}: {
  title: string;
  text: string;
  image?: {
    url: string;
    height?: 'small' | 'standard' | 'tall';
  };
  cta?: LinkProps;
  background?: string;
  reverse?: boolean;
}) => (
  <Box
    style={{ backgroundColor: background }}
    paddingY={['large', 'none']}
    width="full"
  >
    <Columns
      space={['gutter', 'xlarge']}
      reverse={!reverse}
      alignY="center"
      collapseBelow="tablet"
    >
      <Column width="1/2">
        {image && (
          <Box>
            <Box
              width="full"
              borderRadius="standard"
              className={[
                styles.image,
                image.height
                  ? styles.height[image.height]
                  : styles.height.standard,
              ]}
              style={{
                backgroundImage: `url(${image.url})`,
              }}
            />
          </Box>
        )}
      </Column>
      <Column width="1/2">
        <Box
          paddingY={['none', 'large', 'xxlarge']}
          paddingX={['none', 'gutter', 'none']}
        >
          <Stack space="gutter" align="left">
            <Box paddingRight={['none', 'none', reverse ? 'gutter' : 'none']}>
              <Heading level="2">{title}</Heading>
            </Box>
            <Text>{text}</Text>
            {cta ? <CustomLink data={cta} /> : null}
          </Stack>
        </Box>
      </Column>
    </Columns>
  </Box>
);
